import axios from "axios";

import { useAuthStore } from "@/store";

// 전역 axios 인터셉터
// - API 서버(VUE_APP_API_URL)로 가는 모든 요청에 로그인 토큰을 자동으로 붙인다.
//   컴포넌트에서 axios를 직접 호출하는 경우도 모두 포함된다.
// - 401/403 응답이 오면 자동 로그아웃 (fetch-wrapper.js와 동일한 동작)

axios.interceptors.request.use((config) => {
  const { user } = useAuthStore();
  const isApiUrl = (config.url || "").startsWith(process.env.VUE_APP_API_URL);
  if (user?.token && isApiUrl) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const authStore = useAuthStore();
    if ([401, 403].includes(status) && authStore.user) {
      authStore.logout();
    }
    return Promise.reject(error);
  }
);
